/** Where support is reached: Profile's "Contact support", and the ban screen. */
export const SUPPORT_CHAT = 'https://t.me/pxc_mining_support';
